// src/components/Mapa.jsx

export default function Mapa() {
  return (
    <section className="mapa">
      <h2>UBICACIÓN 👇</h2>
      <div className="mapa-container">
        <iframe
          title="Ubicación Detailing Center"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3406.9438499011653!2d-64.2003071639709!3d-31.36052865867528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x943298f22d9ba6fd%3A0xdfa509298a89942d!2sDetail%20Center%20C%C3%B3rdoba%20%7C%20Est%C3%A9tica%20Vehicular%20%7C%20Car%20Detail!5e0!3m2!1ses!2sar!4v1751305316169!5m2!1ses!2sar"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}
